import type { NotificationProps } from '@mantine/notifications';
import { showNotification } from '@mantine/notifications';
import { IconAlertCircle } from '@tabler/icons-react';
import { ButtonLink } from '~/domains/design-system/Button';
import { Text } from '~/domains/design-system/Text';

type ShowSplashNotificationProps = NotificationProps & {
  showSupportCTA?: boolean;
};

const CS_BUTTON_WIDTH = 124;

export const showSplashNotification = ({
  title,
  message,
  showSupportCTA = false,
  ...props
}: ShowSplashNotificationProps) =>
  showNotification({
    title,
    message,
    ...props,
    ...(showSupportCTA
      ? {
          styles: {
            root: {
              '& .mantine-Notification-icon': {
                backgroundColor: 'transparent',
              },
            },
            body: {
              marginRight: CS_BUTTON_WIDTH + 24,
            },
          },
          autoClose: false,
          disallowClose: true,
          icon: (
            <>
              <IconAlertCircle color="#EB612A" />
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  right: 16,
                  width: CS_BUTTON_WIDTH,
                }}
              >
                <ButtonLink
                  size="small"
                  variant="secondary-fill"
                  href={`mailto:support@splashsports.com?subject=Error Message: "${title}"&body=I received the following error message: "${message}"`}
                >
                  <Text style={{ whiteSpace: 'nowrap' }} variant="headline-small" align="center">
                    Contact Support
                  </Text>
                </ButtonLink>
              </div>
            </>
          ),
        }
      : {}),
  });

export const useShowSplashNotification = () => ({
  showSplashNotification,
});
